import React from 'react';
import { SubscriptionLayout } from '../components/SubscriptionLayout';
import { PaymentMethods } from '../components/PaymentMethods';

export const PaymentMethodsPage = () => {
  return (
    <SubscriptionLayout activeTab="payment-methods">
      <PaymentMethods />
    </SubscriptionLayout>
  );
};
